"use client";

import React from "react";
import { Button } from "@/components/ui/button";
export default function ReserveATable() {
  return <section data-section-id="142068" id="reserve-the-table" className="relative w-full py-[150px] flex items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <style>{`
        @keyframes shimmer-slide {
          0% { transform: translateX(-150%) skewX(-15deg); }
          15% { transform: translateX(250%) skewX(-15deg); }
          100% { transform: translateX(250%) skewX(-15deg); }
        }
        .animate-shimmer-slide {
          animation: shimmer-slide 5s infinite ease-in-out;
        }
      `}</style>

      {}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover z-0" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/kitchen_atmosphere_poster.png">
        {}
        <source src="https://cdn.pixabay.com/video/2020/05/24/40135-424822598_large.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 bg-black/60 z-10 pointer-events-none"></div>

      {}
      <div className="relative z-20 flex flex-col items-center text-center px-4 w-full max-w-5xl mx-auto">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white mb-12 tracking-tight drop-shadow-lg">
          Host Your Next Unforgettable Moment.
        </h2>

        {}
        <div className="bg-card/20 backdrop-blur-md border border-white/20 shadow-2xl rounded-2xl p-8 md:p-10 w-full max-w-md flex flex-col items-center transform transition-transform hover:scale-[1.02] duration-500">
          <p className="text-white/80 mb-8 text-sm md:text-base font-sans font-medium uppercase tracking-widest">
            Ample Parking Available in Peliatan
          </p>
          
          <Button size="lg" className="relative w-full h-14 text-lg font-sans font-semibold rounded-xl overflow-hidden bg-primary text-primary-foreground hover:bg-primary/90 border border-primary/50 shadow-xl transition-all duration-300 group">
            <span className="relative z-10">WhatsApp: Check Availability</span>
            
            {}
            <div className="absolute inset-0 z-0 flex pointer-events-none">
              <div className="w-1/2 h-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shimmer-slide" />
            </div>
          </Button>
        </div>
      </div>
    </section>;
}